export default {
  getServiceList: (state) => state.serviceList,
}



// WEBPACK FOOTER //
// ./src/store/serviceStore/getters.js